import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EmployerService } from '../../employer.service';
import { AuthService } from 'src/app/auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-view-job',
  templateUrl: './view-job.component.html',
  styleUrls: ['./view-job.component.css']
})
export class ViewJobComponent implements OnInit {
  emp_uid;
  job_data = [];
  modal_data;
  visible = true;
  editData;
  IsSide: boolean;
  jobId;
  cursor: boolean = true;
  postedData = [];
  draftData = [];

  constructor(private empService: EmployerService, private auth: AuthService, private router: Router) { }

  ngOnInit() {
    this.auth.getUserId().subscribe(
      (user) => {
        this.emp_uid = user.uid;
        this.empService.getPostJob({ "emp_id": this.emp_uid }).subscribe((a) => {
          console.log(a);
          if (a) {
            //  this.job_data = a;
            this.empService.updateJobData(a)
          }
        })
      }
    );
    this.getJobData();
  }

  getJobData() {
    this.empService.jobData.subscribe((a) => {
      console.log(a);
      if (a) {
        this.job_data = a;
        console.log(a)
        if (this.job_data.length > 0) {
          this.visible = false;
        }        
        this.postedData = [];
        this.draftData = [];
        
        for(let x in this.job_data){
          
          if(this.job_data[x].status == 'Posted')
          {
            this.postedData.push(this.job_data[x]);
          }
          else if(this.job_data[x].status == 'Draft'){
            this.draftData.push(this.job_data[x]);
          }
        }
      }
    })
  }

  onCardClick(data) {
    this.modal_data = data;
    // this.editData = data;
    //this.router.navigate([`/detailed/${this.modal_data._id}`]);
    if(data.status == 'Posted'){
      const url = this.router.serializeUrl(
        this.router.createUrlTree([`/detailed/${this.modal_data._id}`])
      );
      window.open(url, '_blank');
    }
  }

  editJob(data?) {
    this.empService.editJobData = data;
    console.log(this.empService.editJobData);
    this.router.navigate(['/employer-dashboard/post-job']);
  }

  deleteJob(data) {
    console.log(data);
    this.empService.deleteJob({ _id: data._id }).subscribe((a) => {
      this.job_data.splice(this.job_data.indexOf(data), 1);
      if(data.status == 'Posted'){
        this.postedData.splice(this.postedData.indexOf(data), 1);
      }
      else if(data.status == 'Draft'){
        this.draftData.splice(this.draftData.indexOf(data), 1);
      }
      console.log(this.job_data)
    }),
      (error) => {
        console.log(error);
      }
  }

  onHover(data){
    if(data.status == 'Draft'){
      this.cursor = false;
    }
    else{
      this.cursor = true;
    }
  }

  more($event){
    $event.stopPropagation();
  }

}
